import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { AuthContext } from "./../../context/auth";
import {ApiBaseUrl} from '../../constants';
import Moment from 'react-moment';
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class PurchasedAlldayDetail extends Component{
    static contextType = AuthContext;
    state = {
        data: []
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        trackPromise(
        fetch(ApiBaseUrl+"/consumer/purchased_deals/all/"+this.props.match.params.id,
            {
                method: 'GET',
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(!result.success)
                        this.props.openSnackbar(result.message)
                    else
                        this.setState({
                            data: result.data
                        });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    render(){
        return (
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container ux-grid">

                    <div className="row">
                        <div className="deals-tab-outer font-0 outer-glow1 mx-auto">
                            <Link to={process.env.PUBLIC_URL+'/cart/purchased/allday/'+this.props.match.params.id} className="tabing-text">Per Person Deals</Link>
                            <Link to={process.env.PUBLIC_URL+'/cart/purchased/oneday/'+this.props.match.params.id} className="tabing-text grad-on">Group Deals</Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className="purchased-deal-outer mt-5">
                            {this.state.data.length > 0 ?
                            this.state.data.map(deal => (
                                <Link to={process.env.PUBLIC_URL+'/oneday/entry-pass/'+deal._id} key={deal._id} className="each--associatehost-row overlay-bg p-t-15">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <div className="eacch--associatehost-outer d-mob-flex d-md-flex d-lg-flex custom-w-100">
                                                <div className="each--associatehost-pic">
                                                    <img src={deal.image} alt={deal.name}/>
                                                </div>
                                                <div className="each--associatehost-info">
                                                    <h6 className="each--associatehost-info-heading custom-height text_color_green">{deal.category.name}</h6>
                                                    <p className="each--associatehost-info-para custom-height">{deal.name}</p>
                                                    <div className="d-flex align-items-center justify-content-between custom-mt-15">
                                                        <p className="each--associatehost-info-para"><Moment format="DD MMM">{deal.deal_at}</Moment> <br/>({deal.is_redeemed ? 'Redeemed' : 'Not Redeemed'})</p>
                                                        <div className="view-host-deals">
                                                            <Link to={process.env.PUBLIC_URL+'/oneday/entry-pass/'+deal._id} className="grad-on cart-view-btn fav-custom-btn">View Details</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))
                            :
                            <div className="col-12 text-center text-white">No group deal purchased in this cart</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withSnackbar(PurchasedAlldayDetail,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});